// extracted by mini-css-extract-plugin
export var resourceAction = "DevelopmentResources-module__resourceAction___K1Nm4";
export var resourceCard = "DevelopmentResources-module__resourceCard___xiPT-";
export var resourceCardFeatured = "DevelopmentResources-module__resourceCardFeatured___KZVgH";
export var resourceGrid = "DevelopmentResources-module__resourceGrid___qeAa+";
export var resourceIconLink = "DevelopmentResources-module__resourceIconLink___y3BN-";
export var resources = "DevelopmentResources-module__resources___Gctbq";